import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const ErrorPage404 = () => {
  const { platformData } = useSelector(state => state.frontend);
  return (
    // TODO: conditionally apply left padding ("lg:pl-80") if leftsidebar is visible.
    // Requires a refactor to make isLeftNavbarVisible globally accessible
    <div className="min-h-full w-full lg:pl-80 pt-16 pb-12 flex flex-col bg-white">
      <main className="flex-grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-16">
          <div className="text-center">
            <p
              className="text-7xl font-semibold "
              style={{ color: `${platformData.primaryColor}` }}
            >
              404
            </p>
            <h1 className="mt-2 text-4xl font-bold text-gray-900 tracking-tight sm:text-5xl sm:tracking-tight">
              Oops!
            </h1>
            <p className="mt-2 text-base text-gray-500">
              Well this is awkward... we couldn't find the page you tried to reach. Click the button
              below to go home.
            </p>
            <div className="mt-6">
              <Link
                to="/"
                className="text-base font-medium"
                style={{ color: `${platformData.primaryColor}` }}
              >
                Take me home!<span aria-hidden="true"> &rarr;</span>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ErrorPage404;
